import { dataFetch } from '@lib/ggj-utils'

export default {

  // 模板
	noticeTeacher(params) {
    return dataFetch('/wholesale/api/teacher/noticeTeacher', params, {
      method: 'get',
    })
  },
  getTeacherInfo(params) {
    return dataFetch('/wholesale/api/teacher/teacherInfo', params, {
      method: 'get',
    })
  },
  modifyAccount(params) {
    return dataFetch('/user-customer-web/api/account/modify', params)
  },
  getPersonalInfo(params) {
    return dataFetch('/user-customer-web/api/account/personalInfo', params)
  }
  
}
